import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
    //路由配置
export default new Router({
    routes: [{
            //默认页
            path: '/',
            name: 'Home',
            component: resolve => require(['@/components/home/home'], resolve)
        },
        //bio
        {
            path: '/home/home_bio',
            name: 'Home_bio',
            component: resolve => require(['@/components/home/home_bio'], resolve)
        },
        //皇家酵素
        {
            path: '/home/home_hj',
            name: 'Home_hj',
            component: resolve => require(['@/components/home/home_hj'], resolve)
        },
        
        //牌子的秘密
        {
            path: '/home/pingzi',
            name: 'pingzi',
            component: resolve => require(['@/components/home/pingzi'], resolve)
        },
        
        //环球港
        {
            path: '/home/anabhqg',
            name: 'anabhqg',
            component: resolve => require(['@/components/home/anabhqg'], resolve)
        },
        
        //做梦的人
        {
            path: '/home/dream',
            name: 'dream',
            component: resolve => require(['@/components/home/dream'], resolve)
        },
        
        //追溯本源
        {
            path: '/home/source',
            name: 'source',
            component: resolve => require(['@/components/home/source'], resolve)
        },
        
        //北京浅草
        {
            path: '/home/beijing',
            name: 'beijing',
            component: resolve => require(['@/components/home/beijing'], resolve)
        },
        
        //环球港
        {
            path: '/home/graduate_school',
            name: 'graduate_school',
            component: resolve => require(['@/components/home/graduate_school'], resolve)
        },

        //产品
        {
            path: '/product/product',
            name: 'Product',
            component: resolve => require(['@/components/product/product'], resolve)
        },
         //产品分类列表
        {
            path: '/product/product_list/:id',
            name: 'Product_list',
            component: resolve => require(['@/components/product/product_list'], resolve)
        },
        {
            path: '/mj_school/mj_school',
            name: 'Mj_school',
            component: resolve => require(['@/components/mj_school/mj_school'], resolve)
        },

        //最新资讯列表
        {
            path: '/new_consult/new_consult',
            name: 'New_consult',
            component: resolve => require(['@/components/new_consult/new_consult'], resolve),
        },
        //最新资讯下详细资讯1
        {
            path: '/new_consult/consult_details1',
            name: 'Consult_details1',
            component: resolve => require(['@/components/new_consult/consult_details1'], resolve),
        },
        //最新资讯下详细资讯2
        {
            path: '/new_consult/consult_details2',
            name: 'Consult_details2',
            component: resolve => require(['@/components/new_consult/consult_details2'], resolve),
        },

        //anab爱柔肤
        {
            path: '/anab/anab',
            name: 'Anab',
            component: resolve => require(['@/components/anab/anab'], resolve)
        },
        {
            path: '/shoppe/shoppe',
            name: 'Shoppe',
            component: resolve => require(['@/components/shoppe/shoppe'], resolve)
        },
        //
        {
            path: '/lr_img/lr_img',
            name: 'Img',
            component: resolve => require(['@/components/lr_img/lr_img'], resolve)
        },
        // 美肌学堂 单个列表
        {
          path:'/mj_school/singleProduct/:id',
          name: 'SingleProduct',
          component: resolve => require(['@/components/mj_school/singleProduct'], resolve)
        },
        // 美肌学堂 详情页
        {
          path:'/mj_school/mj_schoolDetails/:id',
          name:'Mj_schoolDetails',
          component: resolve => require(['@/components/mj_school/mj_schoolDetails'], resolve)
        },
        // 使用条款
        {
          path:'/home/terms',
          name:'Terms',
          component: resolve => require(['@/components/home/terms'], resolve)
        },
        // 美肌学堂产品 大图

        /*{
          path: '/mj_school/mj_school',
          name: 'Mj_school',
          component: Mj_school
        },*/
        /*{
          path: '/new_consult/new_consult',
          name: 'New_consult',
          component: New_consult
        },*/
        /*{
          path: '/anab/anab',
          name: 'Anab',
          component: Anab
        },*/
        /*{
          path: '/shoppe/shoppe',
          name: 'Shoppe',
          component: Shoppe
        },*/
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js